// Контакт клиента для проверки БМГ на шаге согласий.
//
// Страница сделки держит клиента в памяти с момента открытия. Менеджер меняет
// телефон в карточке клиента в другой вкладке, а сделка продолжает подставлять
// старый номер в проверку и получает отказ (сделка 191883: новый номер прошёл
// проверку в 15:12:08, а шаг 4 ещё три раза проверял старый). Поэтому перед
// проверкой перечитываем клиента с сервера, а память страницы — запасной путь.

// Сервис БМГ не ответил (500/таймаут на нашем бэкенде): менеджеру нужен понятный
// текст и совет, что делать, а не модалка «Подробности для разработчика».
export const BMG_UNAVAILABLE_MESSAGE =
  'Не удалось проверить номер в Базе Мобильных Граждан: сервис не ответил. Попробуйте ещё раз через минуту, если ошибка повторится — сообщите администратору.';

export const BMG_PHONE_MISMATCH_MESSAGE =
  'Клиент с этим ИИН не является владельцем введенного номера телефона и не проходит проверку Базы Мобильных Граждан. Попросите клиента предоставить другой номер телефона, либо предложите ему поменять свой номер телефона в Базе Мобильных Граждан.';

const clean = (value) => (value === null || value === undefined ? '' : String(value).trim());

/**
 * Телефон и ИИН для проверки: из свежей карточки, если она есть и заполнена,
 * иначе из того, что лежит в сделке.
 */
export const pickClientContact = (freshClient, dealClient) => {
  const phone = clean(freshClient?.phone) || clean(dealClient?.phone);
  const iin = clean(freshClient?.iin) || clean(dealClient?.iin);
  return { phone, iin };
};

/** Свежая карточка клиента; при любой ошибке — null, проверка пойдёт по данным сделки. */
export const loadFreshClient = async (getClients, clientId) => {
  if (!clientId) return null;
  try {
    const res = await getClients({ id: clientId });
    return res?.data?.users?.[0] || null;
  } catch (e) {
    return null;
  }
};
